import actionTypes from "../actionTypes";

export function setGameUrl(url: any) {
  return {
    type: actionTypes.SET_GAME_URL,
    url
  }
}

export function resetGameUrl() {
  return {
    type: actionTypes.RESET_GAME_URL
  }
}

export function requestGameUrl(game: { id: any }) {
  return {
    type: actionTypes.REQUEST_GAME_URL,
    game
  }
}

export function failGameUrl( msg: any ) {
  return {
    type: actionTypes.FAIL_GAME_URL,
    msg
  }
}